import AccessTimeIcon from "@mui/icons-material/AccessTime";
import PersonIcon from "@mui/icons-material/Person";
import { Stack, Typography } from "@mui/material";

import { ISOStringToLocalReadableTimestamp } from "utils";

interface AnswerAuthorProps {
  isPartnerShipment: boolean;
  firstName?: string;
  timestamp?: string;
}

export function AnswerAuthor(props: AnswerAuthorProps) {
  const { isPartnerShipment, firstName, timestamp } = props;

  return (
    <Stack direction="row" mt="1rem" mb="1rem" spacing={3}>
      <Stack direction="row" spacing={1} alignItems="center">
        <PersonIcon />
        <Typography variant="body1">
          {isPartnerShipment ? (firstName ?? "-") : "SHIPPER"}
        </Typography>
      </Stack>
      <Stack direction="row" spacing={1} alignItems="center">
        <AccessTimeIcon />
        <Typography variant="body1">
          {timestamp ? ISOStringToLocalReadableTimestamp(timestamp) : "-"}
        </Typography>
      </Stack>
    </Stack>
  );
}
